/**
 * Форма нового процесса (/processes/new/[form], напр. /processes/new/vac) — подмаршрут выбора,
 * чтобы «назад» возвращал к выбору, а ссылку на форму можно было открыть напрямую. Вид без формы
 * (или скрытый гейтом, как «Договор» при EXPO_PUBLIC_CONTRACT=0) уводит обратно к выбору.
 * Форма закрывается (отправка или «Отмена» — onDone у форм общий) на «Моих заявках».
 */
import { Redirect, useLocalSearchParams, useRouter } from 'expo-router'
import { Text } from 'tamagui'

import { useApp } from '../../../../src/i18n'
import { useDocumentTitle } from '../../../../src/lib/useDocumentTitle'
import { CREATE_TYPES, FORMS } from '../../../../src/features/edo/createTypes'
import { Breadcrumb } from '../../../../src/features/edo/components/Breadcrumb'
import { Card } from '../../../../src/ui'
import { Page } from '../../../../src/ui/Screen'

export default function NewProcessFormScreen() {
  const { l, t } = useApp()
  const router = useRouter()
  const { form } = useLocalSearchParams<{ form: string }>()
  const picked = CREATE_TYPES.some((pt) => pt.id === form) ? FORMS[String(form)] : undefined
  useDocumentTitle(picked ? t(picked.title) : null)

  if (!picked) return <Redirect href="/processes/new" />
  const { title, Form } = picked
  return (
    <Page>
      <Breadcrumb items={[{ label: l('proc.title'), href: '/processes' }, { label: l('doc.new'), href: '/processes/new' }, { label: t(title) }]} />
      <Card padding={20} gap={16}>
        <Text fontSize={15} fontWeight="700" color="$color" role="heading">
          {t(title)}
        </Text>
        <Form onDone={() => router.replace({ pathname: '/processes', params: { tab: 'mine' } })} />
      </Card>
    </Page>
  )
}
